import { createFileRoute, redirect } from "@tanstack/react-router";

import { PATH_REDIRECTS } from "@/routing/pathRedirects";

export const Route = createFileRoute("/_app/profile/profile")({
  beforeLoad: () => {
    throw redirect({ to: PATH_REDIRECTS.get("/profile/profile") as string });
  },
});
